import { render, staticRenderFns } from "./importCustom.vue?vue&type=template&id=c9abdd92&scoped=true&"
import script from "./importCustom.vue?vue&type=script&lang=js&"
export * from "./importCustom.vue?vue&type=script&lang=js&"
import style0 from "./importCustom.vue?vue&type=style&index=0&id=c9abdd92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9abdd92",
  null
  
)

component.options.__file = "importCustom.vue"
export default component.exports